/* src/app/shared-module/components/delete-confirm-dialog/delete-confirm-dialog.component.scss */
:host {
  display: block;
}
.dialog-shell {
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-light-tint);
  border-radius: 14px;
  overflow: hidden;
}
.dialog-accent-line {
  height: 4px;
  width: 100%;
  background:
    linear-gradient(
      90deg,
      var(--ion-color-dark) 0%,
      var(--ion-color-primary) 100%);
}
.dialog-title {
  margin: 0;
  padding: 16px 16px 8px;
  color: var(--ion-color-secondary-shade);
  font-size: 20px;
  font-weight: 700;
}
.dialog-content {
  margin: 0;
  padding: 0 16px 14px;
}
.dialog-message {
  margin: 0;
  color: var(--ion-color-primary-contrast);
  font-size: 15px;
  line-height: 1.5;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 16px 16px;
}
.action-btn {
  min-width: 90px;
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  padding: 10px 14px !important;
}
.cancel-btn {
  color: var(--ion-color-secondary-shade) !important;
  background: var(--ion-color-primary-tint) !important;
}
.confirm-btn {
  color: var(--ion-color-secondary) !important;
  background: var(--ion-color-primary) !important;
}
.confirm-btn:hover,
.cancel-btn:hover {
  filter: brightness(0.98);
}
/*# sourceMappingURL=delete-confirm-dialog.component.css.map */
